<div class="jeopary-select-country">
  <h2>{{i18n.str('challengeu.profiles_select_profile', 'Select profile')()}}</h2>

  <div class="profiles-container">
    <button type="button" class="arrow left" [disabled]="profileIndex === 0"
            (click)="skipProfile($event, 'left')" aria-label="Previous profile"
            title="Click to shift the list of profiles to the left"></button>
    <div class="profiles-viewport">
      <ul class="profiles-wrapper" [style.transform]="'translateX(-' + profileIndex * 100 + '%)'">
        @for (profile of profiles; track profile.id; let i = $index) {
        <li class="profile-slide" [attr.aria-hidden]="i !== profileIndex"
            [attr.inert]="i !== profileIndex ? '' : null">
          <div class="profile" [class.active]="i === profileIndex">
            <img class="profile-avatar" [src]="profile.avatar"
                 [alt]="i18n.str('challengeu.avatar_picture', 'Your avatar picture')()">
            <h2>{{profile.username}}</h2>
            <div class="profile-details">
              <h3>{{i18n.str('challengeu.profiles_language', 'Language')()}}:
                {{profile.location.language.name}}</h3>
              <h3>{{i18n.str('challengeu.profiles_country', 'Country')()}}:
                {{profile.location.country.value}}</h3>
            </div>
            @if (currentProfile?.id === profile.id) {
            <div class="active-label">{{i18n.str('challengeu.profiles_active', 'ACTIVE')()}}</div>
            }
            <div class="remove-profile">
              @if (currentProfile?.id !== profile.id) {
              <a href="#" (click)="removeProfile($event, profile)"
                 [attr.tabindex]="i === profileIndex ? 0 : -1"
                 [attr.aria-label]="i18n.str('challengeu.profiles_remove_profile', 'Remove profile:')() + ' ' + profile.username"
                 [title]="i18n.str('challengeu.profiles_remove_profile', 'Remove profile:')() + ' ' + profile.username">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </a>
              }
            </div>
          </div>
        </li>
        }
      </ul>
    </div>
    <button type="button" class="arrow right" [disabled]="profileIndex >= profiles.length - 1"
            (click)="skipProfile($event, 'right')" aria-label="Next profile"
            title="Click to shift the list of profiles to the right"></button>
  </div>

  <div class="profile-actions">
    <div class="jeopardy-button primary" [class.disabled]="profiles.length === 0">
      <a href="#" (click)="selectProfile($event)" [attr.aria-disabled]="profiles.length === 0"
         [attr.tabindex]="profiles.length === 0 ? -1 : 0">{{i18n.str('challengeu.profiles_select_profile', 'SELECT PROFILE')()}}</a>
    </div>
    <p class="profiles-or">{{i18n.str('challengeu.profiles_or', 'OR')()}}</p>
    <div class="jeopardy-button primary">
      <a routerLink="/select-language">{{i18n.str('challengeu.profiles_new_profile', 'CREATE NEW PROFILE')()}}</a>
    </div>
  </div>
</div>
